/* eslint-disable @typescript-eslint/naming-convention*/
import { HttpInterceptorFn } from '@angular/common/http';

export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  const clonedRequest = req.clone({
    setHeaders: {
      'Accept-Language': 'fr-FR,fr;q=0.9'
    }
  });
  return next(clonedRequest);
};
